var _desc, _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.250977,
    height: 25.251221,
    viewBox: "0 0 25.251 25.2512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Pixso.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.20117 0L25.251 24.0491L24.0488 25.2512L0 1.20215L1.20117 0Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M18.251 8.20239L25.251 1.20215L24.0488 0L17.043 7.00635L18.251 8.20239ZM13.4277 13.0254L12.2197 11.8291L0 24.0491L1.20215 25.2512L13.4277 13.0254Z",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.36a6a795765dcbf6cee6d54b4cd8e78c.svg";
export { ForwardRef as ReactComponent };